/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import * as DashboardCURD from "./DashboardCRUD";
import {getCSS, getCSSVariableValue} from "../../../_metronic/assets/ts/_utils";
import { formatPrice } from '../../selectors';
import { UserLoggedIn } from '../../hooks/PermissionChecker';

type Props = {
  className: string
  colorBase: string
  totalImportRequests: number
  totalConsignmentStores: number
  totalStores: number

}

const ShowroomCharts: React.FC<Props> = ({
  className, 
  colorBase, 
  totalImportRequests, 
  totalConsignmentStores,
  totalStores
}) => {
  const pieChartRef = useRef<HTMLDivElement | null>(null)
  const barChartRef = useRef<HTMLDivElement | null>(null)
  const labels = ["Showroom đã phát sinh nhập", "Showroom chưa phát sinh nhập"]

  useEffect(() => {
    if (!pieChartRef.current || !totalStores) {
      return
    }
    const height = parseInt(getCSS(pieChartRef.current, 'height'))
  
    const series = [totalConsignmentStores, totalStores - totalConsignmentStores];
    const pieChart = new ApexCharts(pieChartRef.current, getPieChartOptions(height, colorBase, series, labels, totalStores))
    const barChart = new ApexCharts(barChartRef.current, getBarChartOptions(height, colorBase, totalImportRequests))
    if (pieChart) {
      pieChart.render()
    }
    if (barChart) {
      barChart.render()
    }

    return () => {
      if (pieChart) {
        pieChart.destroy()
      }
      if (barChart) {
        barChart.destroy()
      }
    }
  }, [totalStores])

  const emptyData = false;
  const baseColor = getCSSVariableValue(colorBase)
  const secondaryColor = getCSSVariableValue('--bs-success')

  return (
    <>
      <div className='col-lg-8'>
        <div className={`card ${className}`}>
          {/* begin::Header */}
          <div className='card-header border-0 pt-5'>
            <div className="card-title align-items-center d-flex justify-content-center">
              <h3>
                <span className='card-label fw-bolder fs-3 mb-1'>Showroom trong hệ thống sento</span>
              </h3>
            </div>
          </div>
          <div className='card-body pt-0'>
            {emptyData ?
              <div key={`item_key_${emptyData}`}
                  className="d-flex justify-content-center align-items-center text-muted fst-italic"
                  style={{height: '250px'}}>
                Không tìm thấy dữ liệu
              </div>
              :
              <div className='row' style={{alignItems: "center"}}>
                <div className='col-lg-7'>
                  <div ref={pieChartRef} id='kt_charts_widget_2_chart' style={{height: '250px'}}></div>
                </div>
                <div className='col-lg-5'>
                  <div className='mk-chart-data'>
                    <div className='mk-chart-labels'><span style={{backgroundColor: baseColor}}></span>Showroom đã phát sinh nhập</div>
                    <div className='mk-chart-value' style={{color: baseColor}}>{formatPrice(parseInt((totalImportRequests).toFixed(0)))}</div>
                    <p className='text-muted'>Phiếu nhập</p>
                  </div>
                  <div className='mk-chart-data'>
                    <div className='mk-chart-labels'><span style={{backgroundColor: secondaryColor}}></span>Showroom chưa phát sinh nhập</div>
                    <div className='mk-chart-value' style={{color: secondaryColor}}>{formatPrice(totalStores - totalConsignmentStores)}</div>
                    <p className='text-muted'>Showroom</p>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div className='col-lg-4'>
        <div className={`card ${className}`}>
          {/* begin::Header */}
          <div className='card-header border-0 pt-5'>
            <div className="card-title align-items-center d-flex justify-content-center">
              <h3>
                <span className='card-label fw-bolder fs-3 mb-1'>Tổng phiếu nhập từ showroom</span>
              </h3>
            </div>
    
            {/* begin::Toolbar */}
            <div className='card-toolbar text-muted fst-italic' data-kt-buttons='true'>
              Đ/v: Phiếu nhập
            </div>
          </div>
          <div className='card-body pt-0'>
            {emptyData ?
              <div key={`item_key_${emptyData}`}
                    className="d-flex justify-content-center align-items-center text-muted fst-italic"
                    style={{height: '250px'}}>
                Không tìm thấy dữ liệu
              </div>
              :
              <div ref={barChartRef} id='kt_charts_widget_3_chart' style={{height: '250px'}}></div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export {ShowroomCharts}

function getPieChartOptions(height: number, colorBase: string, series: number[], labels: string[], totalStore: number): ApexOptions {
  const baseColor = getCSSVariableValue(colorBase)
  const secondaryColor = getCSSVariableValue('--bs-success')
  return {
    series: series,
    chart: {
      fontFamily: 'inherit',
      type: 'donut',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
            },
            total: {
              show: true,
              showAlways: true,
              label: "Tổng Showroom",
              formatter: function (val) {
                let total = formatPrice(parseInt(totalStore.toFixed(0)))
                if (typeof total === 'number') {
                    total = total.toString();
                }
                return total;
              }
            }
          }
        }
      }
    },
    legend: {
      show: false,
    },
    labels: labels,
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      // y: {
      //   formatter: function (val) {
      //     return val
      //   },
      // },
    },
    colors: [baseColor, secondaryColor]
  }
}

function getBarChartOptions(height: number, colorBase: string, totalImportRequests: number): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue(colorBase)
  const secondaryColor = getCSSVariableValue('--bs-warning')
  const series = [{
    name: 'Phiếu nhập',
    data: [totalImportRequests],
  }];

  return {
    series,
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ["#FFF"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Phiếu nhập'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function(val) {
         let yLabel = formatPrice(parseInt(val.toFixed(0)))
         if (typeof yLabel === 'number') {
            yLabel = yLabel.toString();
         }
         return yLabel; // Example: Format to 2 decimal places
       }
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      // y: {
      //   formatter: function (val) {
      //     return val
      //   },
      // },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}